import { testimonials } from "@/mocks/gossip";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 overflow-hidden bg-gradient-to-b from-background-100 to-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-quill-pen-fill"></i>
              关于吃瓜快手
            </span>
            <h2 className="mt-3 font-display text-3xl font-black leading-tight text-foreground-900 md:text-4xl">
              我们不生产热点
              <br />
              只做快乐的搬运工
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-600 md:text-[15px] md:leading-8">
              吃瓜快手诞生于一群每天在评论区笑到停不下来的编辑之手。我们相信，一条好的热评往往比原帖更有灵魂——
              那是网友集体智慧的闪光时刻。于是我们把散落在各处的神回复、段子、梗图和表情包聚到一处，做成这条好逛的\u201c吃瓜一条街\u201d。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px] md:leading-8">
              在这里，你看到的每一条都经过人工精筛：好笑、有梗、又不失分寸。我们想让快乐简单一点，让吃瓜轻松一点，
              也永远守好那条友善的底线。
            </p>

            <div className="mt-7 grid grid-cols-3 gap-3">
              {[
                { icon: "ri-checkbox-circle-fill", t: "内容精筛" },
                { icon: "ri-time-line", t: "每日三档" },
                { icon: "ri-heart-fill", t: "友善吃瓜" },
              ].map((f, i) => (
                <div
                  key={i}
                  className="flex flex-col items-center gap-2 rounded-2xl border border-background-200 bg-background-50 px-3 py-5 text-center"
                >
                  <i className={`text-2xl text-primary-500 ${f.icon}`}></i>
                  <span className="whitespace-nowrap text-xs font-semibold text-foreground-700 md:text-sm">{f.t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=colorful%20cartoon%20office%20team%20of%20young%20creative%20people%20laughing%20at%20computer%20screens%20flat%20illustration%20warm%20sunny%20modern%20workspace%20memes%20sticky%20notes%20fun%20vibe&width=720&height=560&seq=about-img&orientation=squarish"
              alt="吃瓜快手编辑团队快乐工作场景"
              className="w-full rounded-3xl border border-background-200 object-cover"
              loading="lazy"
            />
            <div className="pointer-events-none absolute -right-4 -top-4 hidden -rotate-6 rounded-2xl bg-primary-500 px-4 py-3 text-background-50 shadow-soft md:block animate-float">
              <p className="font-display text-lg font-bold whitespace-nowrap">今日份快乐 +1</p>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="text-center font-display text-2xl font-black text-foreground-900 md:text-3xl">
            来自吃瓜群众的真实口碑
          </h3>
          <p className="mt-2 text-center text-sm text-foreground-500">
            每一个\u201c哈哈哈哈哈\u201d，都是我们坚持的理由
          </p>

          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.id}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:shadow-soft"
              >
                <div className="flex gap-1 text-secondary-500">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="h-10 w-10 rounded-full border-2 border-background-200 object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="whitespace-nowrap text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}